<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav" :class="{ 'ceil': showHead }">
      <!-- 导航logo -->
      <div class="container center_header">
        <div class="header-nav-logo col-xs-4 col-lg-2">
            <a href="/" aria-label="Relbia Lodge" title="Relbia Lodge" class="site-title">Relbia Lodge</a>
        </div>
      <!-- 导航内容right_header -->
      <div class="right_header col-xs-8 col-lg-10">
        <ul class="header-nav-wrapper">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="item.id==indexs?'active':''"
            @click="navClick(item)"
          >
            <!-- <router-link :to="item.catalogue">
              {{item.title}}
            </router-link> -->
            <a :href="item.catalogue" aria-current="page">{{item.title}}</a>
          </li>
        </ul>
        <div class="head-nav-btn">
          <div class="component-wrap">
            <a href="https://app.channelmanager.com.au/booknow/relbia-lodge-9650" class="button button-primary">BOOK NOW</a>
          </div>
        </div>
      </div>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild" :class="{ 'ceil': showHead }">
      <div class="header-nav-m-logo">
        <a href="/" aria-label="Relbia Lodge" title="Relbia Lodge" class="site-title">Relbia Lodge</a>
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu">
        <div class="zhezhao" v-if="isShow"></div>
        <div 
        class="header-nav-m-menu-wrapper"
        data-toggle="collapse"
        data-target="#menu"
        @click="menuClick"
        >
        
       <div class="svg_style">
        <div v-if="!isShow" class="bars">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
        </div>
        <div v-else class="bars err_bars">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
        </div>
       </div>
       </div>
        <!-- 导航内容 -->
        <div id="menu" class="header-nav-m-wrapper" :class="[isShow ?'header-nav-m-show' :'header-nav-m-show2']">
          <div @click="menuClick" class="close_btn">
            <div class="svg_style">
              <div v-if="!isShow" class="bars err_bars">
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
              </div>
              <div v-else class="bars">
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
              </div>
            </div>
          </div>
          <ul  class="header-nav-m-list">
          <li
            v-for="item in navList"
            :key="item.id"
            :class="item.id==indexs?'active':''"
            @click="navClick(item)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.catalogue">
              {{item.title}}
            </router-link>
            <!-- <a :href="item.catalogue" aria-current="page">{{item.title}}</a> -->
          </li>
        </ul>
        <div class="head-nav-btn">
          <div class="component-wrap">
            <a href="https://app.channelmanager.com.au/booknow/relbia-lodge-9650" class="button button-primary">BOOK NOW</a>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getHeaderList} from "../api/api";
import { mapState,mapMutations } from 'vuex'
export default {
  name: "Header",
  props:{
    showHeight:Boolean
  },
  data() {
    return {
      navList:[],
      showHead:false, // 滚动悬浮header
      selectLange:'', //选择语言
      languagelist:[
      {
          language_id:1,
          title:'English'
        },
        {
          language_id:2,
          title:'简体中文'
        },{
          language_id:3,
          title:'繁體中文'
        }
      ],
      isShow:false, //是否显示下拉
    };
  },
  computed:{
    ...mapState(['indexs','titleName','languageId'])
  },
  methods: {
    ...mapMutations(['changeBack','changeName','upHeaderLanguage']),
    navClick(name) {
      console.log(name.id,'x');
      this.changeBack(name.id)
      this.changeName(name.title)
      this.isShow  = !this.isShow
      window.scrollTo(0,0)
    },
    menuClick() {
      this.isShow  = !this.isShow
    },
    getList() {
      if(this.showHeight) {
        this.showHead = this.showHeight
      }
      getHeaderList().then(res => {
          if(res.code == 0) {
            console.log(res,this.indexs,'res.data.list');
              this.navList = res.data.list
          }
        })
        },
    //滚动事件
    handleScroll() {
      var scrollTop =
        window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop >= 80 || this.showHeight) {
        this.showHead = true
      } else {
        this.showHead = false
      }
    },
change_language (language) {
    this.upHeaderLanguage(language);
    let command = language == 1 ? 'en' : language == 2 ? 'zh' : 'zh_tw'
    this.$i18n.locale = command;
    localStorage.setItem('locale',command)
    console.log(localStorage.getItem('locale'),'xxxxx');
    console.log(language,'language');
    this.languagelist.map(item => {
      if(item.language_id == language) {
        this.selectLange = item.title
      }
    })
    location.reload();
  }
  },
  created() {
    sessionStorage.getItem('dataList')? this.changeBack(sessionStorage.getItem('dataList')):{}
    sessionStorage.getItem('dataName')? this.changeName(sessionStorage.getItem('dataName')):{}
    localStorage.getItem('dataLanguageId')? this.upHeaderLanguage(localStorage.getItem('dataLanguageId')):{}
      // 判断语言
      console.log(localStorage.getItem('dataLanguageId'),this.languageId,'xx');
      if(!localStorage.getItem('dataLanguageId')) {
        let default_lag = localStorage.getItem('locale_place') == 'zh' ? '2' : localStorage.getItem('locale_place') == 'en' ? '1' : '3'
        this.languagelist.map(item => {
          if(item.language_id == default_lag) {
            this.selectLange = item.title
          }
        })
        }else {
          this.languagelist.map(item => {
          if(item.language_id == this.languageId) {
            this.selectLange = item.title
          }
        })
    }
    this.getList()
  },
  // mounted() {
  //   let _this = this
  //   this.$nextTick(() => {
  //       window.addEventListener("scroll", this.handleScroll)
  //     })
  //     window.addEventListener("popstate", function(e) {
  //       _this.navList.forEach((res) => {
  //         if(res.catalogue == e.target.location.pathname.split('/')[1]) {
  //           _this.changeBack(res.id)
  //         }
  //       })
  //       console.log(e.target.location.pathname);
  
  //   });
  // }
};
</script>
<style scoped lang='less'>
@import "../assets/css/babel.less";
/* 顶部 */
#header {
  background-color: #fff;
}
.header-nav {
      display: block;
    }
    .header-nav-m {
      display: none;
    }
.header-nav {
    // position: fixed;
    z-index: 999;
    width: 100%;
    top: 0px;
    left: 0px;
    color: @default-color;
    font-family: 'Open Sans Bold';
  -webkit-transition: 0.4s all ease-in;
    transition: 0.4s all ease-in;
}
#header .header-top {
  height: 50px;
  // color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #13816F;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 76px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  cursor: pointer;
  // width: 160px;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 24px;
  float: left;
  position: relative;
  .site-title {
    padding: 10px 0;
    color: @default-color;
  }
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  // line-height: 80px;
  float: right;
  margin: 0;
  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 10px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #2b2b2b;
  font-size: 14px;
  display: flex;
  align-items: center;
  position: relative;
  &::after {
    position: absolute;
    content: "";
    margin: 0 auto;
    width: 0;
    height: 2px;
    transition: all .3s ease;
    right: 0;
    left: 0;
    bottom: 0;
    pointer-events: none;
    background-color: @select-color;
  }
}
#header .header-nav .header-nav-wrapper .active a {
  color: @select-color;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: @select-color;
  text-decoration: none;
  &::after {
    width: 100%;
  }
  
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
#header .ceil .header-nav-wrapper > li > a {
  color: #000 ;
}
.ceil {
    top: 0;
    background-color: #fff;
    .right_header .language .language_btn .language_btn_txt {
      color: #000;
    }
  }
  .center_header {
    // width: 100%;
    padding: 0;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }
  .right_header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0;
    .language {
      padding:0;
      margin-left: 25px;
      .language_btn {
      padding:8px 20px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      border-radius: 20px;
      border: 1px solid #0084F4;
      .language_btn_txt {
        margin: 0;
        margin-right: 5px;
        color: #fff;
      }
    }
	}
  .head-nav-btn {
    .component-wrap {
      display: flex;
      margin: 4px 0;
      align-items: center;
      justify-content: center;
      a {
        cursor: pointer;
        box-sizing: border-box;
        background: @select-color;
        color: #fff;
        padding: 10px 22px;
        border-radius: 40px;
        margin-left: 20px;
        &:hover {
            background: #656565;
          }
      }
    }
  }
  }
  .header-popover_container {
    width: 190px;
    .title {
      font-size: 18px;
      font-weight: 700;
    }
    .languagelist {
    margin-top: 10px;
    div {
      padding: 8px 10px;
      cursor: pointer;
    }
   }
  }
  .zhezhao {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0,0,0,.5);
    z-index: 999;
  }
  .svg_style {
    padding: 10px 15px;
    border: 1px solid @default-color;
    .bars {
      box-sizing: border-box;
      .icon-bar {
        background-color: @default-color;
        transition: all .1s ease;
        position: relative;
        display: block;
        width: 15px;
        height: 2px;
        &:nth-child(2) {
          margin: 3px 0;
        }
      }
    }
    .err_bars {
      .icon-bar {
        &:nth-child(1) {
          transform: rotate(45deg);
          top: 5px;
        }
        &:nth-child(2) {
          opacity: 0;
        }
        &:nth-child(3) {
          transform: rotate(-45deg);
          bottom: 5px;
        }
      }
    }
  }
  @media screen and (max-width: 991px) {
  #header .header-nav-m .header-nav-m-wrapper .header-nav-m-list li a:hover {
    color: @select-color;
    text-decoration: none;
    &::after {
      width: 100%;
    }
  }
  #header .header-nav-m {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // position: fixed;
    z-index: 999;
    width: 100%;
    top: 0px;
    left: 0px;
  -webkit-transition: 0.4s all ease-in;
    transition: 0.4s all ease-in;
    padding: 0 15px;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    cursor: pointer;
    height: 70px;
    display: flex;
    align-items: center;
    font-size: 24px;
    float: left;
    position: relative;
  .site-title {
    padding: 10px 0;
    color: @default-color;
    font-family: 'Open Sans Bold';
  }
  }


  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: #fff;
    border-radius: 0px 0px 0px 0px;
    transition: 0.6s all ease;
    // opacity: 0.95;
    z-index: 999;
    .header-nav-m-list {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: -15%;
      li {
        width: 100%;
        margin: 10px 0;
        text-align: center;
        a {
          display: flex;
          justify-content: center;
          color: @default-color;
          font-size: 15px;
          font-weight: bold;
          padding: 15px 0;
          width: 100%;
          position: relative;
          &::after {
            position: absolute;
            content: "";
            margin: 0 auto;
            width: 0;
            height: 2px;
            transition: all .1s ease;
            right: 0;
            left: 0;
            bottom: 0;
            pointer-events: none;
            background-color: @select-color;
          }
          span {
            font-size: 10px;
          }
        }
      }
      .active a {
        color:  @select-color;
      }
      }
    .header-nav-m-txt {
      width: 100%;
      position: absolute;
      color: @default-color;
      bottom: 100px;
      display: flex;
      justify-content: center;
      .language_btn {
        padding: 8px 20px;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border-radius: 20px;
        border: 1px solid #0084F4;
        width: 100%;
        p {
          margin:0 ;
          margin-right: 5px;
        }
      }
    }
    .head-nav-btn {
      width: 100%;
      position: absolute;
      bottom: 15%;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      .component-wrap {
        display: flex;
        margin: 4px 0;
        justify-content: center;
        align-items: center;
        a {
          cursor: pointer;
          box-sizing: border-box;
          background: @select-color;
          color: #fff;
          padding: 10px 15px 8px;
          border-radius: 20px;
          // margin-left: 20px;
          &:hover {
            background: #656565;
          }
        }
      }
    }
  }
  .close_btn {
    position: absolute;
    right: 20px;
    top: 20px;
  }
  #header .header-nav-m .header-nav-m-show {
    left: 0;
  }
  #header .header-nav-m .header-nav-m-show2 {
    left: -1000px;
  }
  .header-nav {
        display: none;
      }
      .header-nav-m {
        display: block;
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue